import zingayaCall from './zingayaCall';
import mangoCall from './mangoCall';
import { nonRussiaSpeakingLocales } from './constants/common';

export default function onlineCall(lang) {
  if (!nonRussiaSpeakingLocales.includes(lang)) {
    zingayaCall();

    return;
  }

  mangoCall(lang);
}
